import AddPerson from "./SVG/single-neutral-actions-add.svg?react";

const AddPersonIcon = () => {
  return <AddPerson />;
};

export default AddPersonIcon;
